import { render } from "./projectTeamMembersPopup.vue?vue&type=template&id=303cb420&ts=true"
import script from "./projectTeamMembersPopup.vue?vue&type=script&lang=ts"
export * from "./projectTeamMembersPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__